import {createEntityAdapter, EntityAdapter, EntityState} from "@ngrx/entity";
import {CheckoutRow as Entity} from "./checkout-row.model";
import {IOrderResult, IPageInfo, IResultWithPageInfo, ITableSort} from "../app-store.interfaces";
import {OrderResult} from "../checkout/checkout.model";



export interface CheckoutRowState extends EntityState<Entity> {
    entities: { [id: number]: Entity };
    ids: number[];
    isLoading: boolean;
    error: Error | undefined;
    currentPage: IPageInfo;
    currentEntity: Entity | undefined,
    history: { correlationId: string, payload: Entity | Entity[] | number | number[] | IResultWithPageInfo<Entity> }[];
}

export const checkoutRowEntityAdapter: EntityAdapter<Entity> = createEntityAdapter<Entity>(
    {
        selectId: (checkoutRow: Entity) => checkoutRow.id
    }
);

export const initialState: CheckoutRowState = checkoutRowEntityAdapter.getInitialState({
    entities: [],
    ids: [],
    isLoading: false,
    error: undefined,
    currentPage: { page: { pageNumber: 0, pageSize: 25 }, totalCount: 0},
    currentEntity: undefined,
    history: []
});
